
/*
 * Google Maps functionality
 *
 * global google
 */


// Global vars
var biro_google_map;
var biro_google_map_member_infowindows;


/**
 * Init function callback
 *
 * @see wp_enqueue_script( 'biro-google-maps-async')
 * @link https://developers.google.com/maps/documentation/javascript/marker-clustering
 * @link https://github.com/googlemaps/js-markerclusterer
 *
 * @return {void}
 */
function biro_google_map_init() {


	// Init
	var marker;
	var $map_wrap                      = jQuery( '.biro-google-map' );
	var markers                        = [];
	var cluster_markers                = [];
	biro_google_map_member_infowindows = {};


	// Got a map?
	if ( $map_wrap.length ) {

		// Add map
		biro_google_map = new google.maps.Map(
			$map_wrap[0],
			{
				zoom: 3,
				minZoom: 3,
				maxZoom: 16,
				center: { lat: 25, lng: 50 },
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false,
				zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_BOTTOM }
			}
		);

		// Got members to add?
		if ( typeof biro_members_data !== 'undefined' ) {

			// Add them
			for ( var member_id in biro_members_data ) {
				if (
					biro_members_data.hasOwnProperty( member_id ) &&
					typeof biro_members_data[ member_id ].title !== 'undefined' &&
					biro_members_data[ member_id ].title &&
					typeof biro_members_data[ member_id ].location_data.lat !== 'undefined' &&
					biro_members_data[ member_id ].location_data.lat &&
					typeof biro_members_data[ member_id ].location_data.lng !== 'undefined' &&
					biro_members_data[ member_id ].location_data.lng
				) {

					// Init infowindow
					biro_google_map_member_infowindows[ member_id ] = new google.maps.InfoWindow({
						'maxWidth': $biro_vw_xs ? 300 : 350
					});

					// Add marker
					marker = new google.maps.Marker({
						position:    {
							lat: biro_members_data[ member_id ].location_data.lat,
							lng: biro_members_data[ member_id ].location_data.lng
						},
						map:         biro_google_map,
						icon:        biro_main.img_url + 'map-marker.svg',
						biroMemberID: member_id.split( '_' )[1],
					});
					markers.push( marker );

					// Add for clustering?
					if (
						typeof biro_members_data[ member_id ].cluster === 'undefined' ||
						biro_members_data[ member_id ].cluster
					) {
						cluster_markers.push( marker );
					}

					// Add click listener
					google.maps.event.addListener( marker, 'click', biro_google_map_member_click );

				}
			}

			// Map click event
			biro_google_map.addListener( 'click', biro_google_map_click );

			// Create custom rendered for clusters
			const renderer = {
				render: ({ count, position }) =>
					new google.maps.Marker({
						position,
						label: { text: String( count ), color: "white", fontSize: "15px" },
						icon: biro_main.img_url + 'map-cluster.svg',
						zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
					}),
			};

			// Add clusterer
			const marker_clusterer = new markerClusterer.MarkerClusterer({
				map: biro_google_map,
				markers: cluster_markers,
				renderer: renderer
			});

		}

	}


}


/**
 * Callback for clicking the map
 */
function biro_google_map_click() {

	// Close any open infowindows
	biro_google_maps_close_infowindows();

}


/**
 * Callback for clicking a member
 */
function biro_google_map_member_click( event ) {

	// Init
	var member_id  = this.get( 'biroMemberID' );
	var iw_content = '';

	// Check for member ID
	if ( member_id ) {

		// Init
		var id_prop = 'id_' + member_id;

		// Close any open infowindows
		biro_google_maps_close_infowindows();

		// Build content for infowindow
		if ( typeof biro_members_data[ id_prop ].title !== 'undefined' ) {
			iw_content += '<h2 class="biro-iw-title">' + biro_members_data[ id_prop ].title + '</h2>';
		}
		if (
			typeof biro_members_data[ id_prop ].teaser !== 'undefined' &&
			biro_members_data[ id_prop ].teaser
		) {
			iw_content += '<p class="biro-iw-teaser">' + biro_members_data[ id_prop ].teaser + '</p>';
		}
		if (
			typeof biro_members_data[ id_prop ].url !== 'undefined' &&
			biro_members_data[ id_prop ].url
		) {
			iw_content += '<p class="biro-iw-link"><a href="' + biro_members_data[ id_prop ].url + '">' + biro_members_data[ id_prop ].url + '</a></p>';
		}

		// Wrap infowindow contents
		iw_content = '<div class="biro-iw-content">' + iw_content + '</div>';

		// Configure and open infowindow
		biro_google_map_member_infowindows[ id_prop ].setContent( iw_content );
		biro_google_map_member_infowindows[ id_prop ].setPosition( event.latLng );
		biro_google_map_member_infowindows[ id_prop ].open( biro_google_map );

		// Blur link
		jQuery( '.biro-iw-link' ).find( 'a' ).blur();

	}

}


/**
 * Close any open infowindows
 *
 * @return void
 */
function biro_google_maps_close_infowindows() {
	for ( var member_id in biro_google_map_member_infowindows ) {
		if ( biro_google_map_member_infowindows.hasOwnProperty( member_id ) ) {
			biro_google_map_member_infowindows[ member_id ].close();
		}
	}
}
